import { Controller } from '@hotwired/stimulus'

import { insertTextIntoField } from 'text-field-edit';

// js companion code for `char_picker` partial
export default class extends Controller {
  static targets = [
    'toggleBtn',
    'charGrid',
  ]

  static values = {
    editableMatcher: {
      type: String,
      default: 'input[type=text]:not([readonly]), textarea:not([readonly])',
    },
  }

  connect () {
    this.editable = null // focused element matching `editableMatcherValue`
    this.shown = false // open state of char picker
  }

  insertChar (e) {
    const btn = e.target.closest('button')
    if (
      this.editable && btn
      && this.charGridTargets.some(grid => grid.contains(btn))
    ) {
      const input = this.editable
      const selectedChar = btn.textContent

      insertTextIntoField(this.editable, selectedChar)
    }
  }

  onFocusin (e) {
    const el = e.target
    if (
      el.matches(this.editableMatcherValue)
    ) {
      this.toggleBtnTarget.disabled = false
      this.editable = el
    }
  }

  onFocusout (e) {
    if (
      e.target.matches(this.editableMatcherValue)
      && !this.element.contains(e.relatedTarget) // focus not moved to picker
      && !this.shown
    ) {
      this.toggleBtnTarget.disabled = true
      this.editable = null
    }
  }

  onShowPicker (_) {
    this.shown = true
  }

  onHidePicker (_) {
    this.shown = false
    if (this.editable) {
      setTimeout(() => this.editable.focus())
    }
  }
}
